import UserTable from "./components/UserTable";
import UserForm from "./components/UserForm";
import { useUserContext } from "./provider/UserContext";

const DisplayUsers = () => {
  const { loading } = useUserContext();
  if (loading === "userFetching") {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-lg font-semibold text-gray-600">
          Fetching user data, please wait...
        </p>
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-hidden p-4 ">
      <UserTable />
      <UserForm />
    </div>
  );
};
export default DisplayUsers;
